module.exports = "pegasus_template/assets/preview-16.png";